// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InboundEmailsDetail_detail_container__hY55I {
  left: 300px;
  position: relative;
  display: flex;
  width: calc(100% - 300px);
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  height: calc(100vh - 211px);
}

.InboundEmailsDetail_top_row__crKwU {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  width: 850px;
}

.InboundEmailsDetail_detail_row__kBaDi {
  background-color: white;
  max-width: 850px;
  border: 3px solid whitesmoke;

  min-width: 850px;
  padding: 8px;
}

.InboundEmailsDetail_detail_scrollbar__xn-cz {
  margin-top: 36px !important;
}

.InboundEmailsDetail_btn_default__nAqUF {
  color: var(--color-font-10) !important;
  border: 1px solid rgba(0, 0, 0, 0.23) !important;
  margin-top: 10px !important;
}

.InboundEmailsDetail_btn_default__nAqUF:disabled {
  color: var(--color-font-10) !important;
  border: 1px solid rgba(0, 0, 0, 0.23) !important;
  margin-top: 10px !important;
  opacity: 0.6;
}

.InboundEmailsDetail_email_iframe__V-QNb {
  width: 100%;
  height: 500px;
  border: none;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/InboundEmailsDetail/InboundEmailsDetail.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;;EAE5B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;EAChD,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;AACd","sourcesContent":[".detail_container {\n  left: 300px;\n  position: relative;\n  display: flex;\n  width: calc(100% - 300px);\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-items: center;\n  height: calc(100vh - 211px);\n}\n\n.top_row {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  flex-wrap: nowrap;\n  width: 850px;\n}\n\n.detail_row {\n  background-color: white;\n  max-width: 850px;\n  border: 3px solid whitesmoke;\n\n  min-width: 850px;\n  padding: 8px;\n}\n\n.detail_scrollbar {\n  margin-top: 36px !important;\n}\n\n.btn_default {\n  color: var(--color-font-10) !important;\n  border: 1px solid rgba(0, 0, 0, 0.23) !important;\n  margin-top: 10px !important;\n}\n\n.btn_default:disabled {\n  color: var(--color-font-10) !important;\n  border: 1px solid rgba(0, 0, 0, 0.23) !important;\n  margin-top: 10px !important;\n  opacity: 0.6;\n}\n\n.email_iframe {\n  width: 100%;\n  height: 500px;\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"detail_container": `InboundEmailsDetail_detail_container__hY55I`,
	"top_row": `InboundEmailsDetail_top_row__crKwU`,
	"detail_row": `InboundEmailsDetail_detail_row__kBaDi`,
	"detail_scrollbar": `InboundEmailsDetail_detail_scrollbar__xn-cz`,
	"btn_default": `InboundEmailsDetail_btn_default__nAqUF`,
	"email_iframe": `InboundEmailsDetail_email_iframe__V-QNb`
};
export default ___CSS_LOADER_EXPORT___;
